import * as React from "react";

function SassIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M12 2a10 10 0 0110 10 10 10 0 01-10 10A10 10 0 012 12 10 10 0 0112 2m-2 13.33c.16.54.14 1.04 0 1.5 0 .05-.04.1-.06.17-.02 0-.04.07-.07.12-.11.24-.27.47-.46.67-.58.64-1.41.88-1.74.68-.38-.22-.17-1.12.49-1.83.72-.76 1.76-1.26 1.76-1.26l.08-.05m8.27-9.05c-.45-1.78-3.4-2.36-6.18-1.37-1.66.59-3.46 1.51-4.75 2.72-1.53 1.44-1.78 2.69-1.68 3.21.34 1.84 2.88 3.05 3.92 3.94v.01c-.3.15-2.54 1.28-3.08 2.44-.54 1.22.1 2.1.5 2.22 1.34.36 2.69-.29 3.41-1.38.7-1.04.65-2.39.34-3.07.42-.1.91-.15 1.53-.08 1.76.21 2.1 1.3 2.03 1.76-.06.46-.43.71-.55.79-.12.07-.16.1-.15.16.01.08.07.08.17.06.15-.03.93-.37.96-1.22.04-1.08-.99-2.28-2.81-2.25-.75.02-1.22.09-1.56.22l-.08-.09c-1.13-1.2-3.21-2.05-3.12-3.67.03-.59.23-2.13 4-4.01 3.08-1.54 5.55-1.12 5.98-.17.61 1.33-1.32 3.82-4.52 4.18-1.22.14-1.87-.34-2.03-.51-.17-.17-.19-.2-.25-.17-.11.07-.04.23 0 .33.09.25.49.67 1.15.91.59.19 2.03.3 3.76-.37 1.94-.75 3.46-2.84 3.01-4.59z" />
    </svg>
  );
}

export default SassIcon;
